import React from 'react';
import { Accordion, Card, Form } from 'react-bootstrap';
import { get } from '../../utils/utils';
import styles from './BuildForm.module.css';
// import { useIntl } from 'react-intl';
import { renderField, hasEnabledFields } from '../../utils/renderFields';

const BuildForm = ({ layoutSchema, formSchema, form, saveForm, errors, setErrors, isReadOnly, fieldSettings, setIsFormDirty, openSection, setOpenSection, updateField, embeddedContent = [], insertValues = {}, spaceProfilePhotos, setSpaceProfilePhotos }) => {
  // const intl = useIntl();
  // const t = (id) => intl.formatMessage({ id });

  return layoutSchema.map((category, i) => {
    const layout = category.sections.map(section => {
      let subsections = section.subsections.map(subsection => {
        const subsectionFields = subsection.keys.map(key => {
          const field = renderField[get(formSchema, `${key}.type`, 'text')](key, form, formSchema, fieldSettings, updateField, saveForm, isReadOnly, errors, setErrors, spaceProfilePhotos, setSpaceProfilePhotos);
          return field && <div key={key} className={`${styles.field} pr-5`} style={subsection.width || get(formSchema, `${key}.width`) ? { width: get(formSchema, `${key}.width`) || subsection.width } : {}}>
            {field}
          </div>
        })

        const toggleField = subsection.toggleKey && hasEnabledFields(subsection.keys, formSchema, fieldSettings) &&
          renderField[get(formSchema, `${subsection.toggleKey}.type`, 'boolean')](subsection.toggleKey, form, formSchema, fieldSettings, updateField, saveForm, isReadOnly, errors, setErrors, spaceProfilePhotos, setSpaceProfilePhotos);

        return <div key={'' + subsection.label + i} className="w-100 d-flex flex-wrap">
          {(subsection.label && hasEnabledFields(subsection.keys, formSchema, fieldSettings)) || toggleField ?
            <div className="d-flex align-items-center flex-wrap w-100 mt-sm-5 mb-sm-3 mt-4 mb-2">
              {subsection.label && hasEnabledFields(subsection.keys, formSchema, fieldSettings) && <p key={subsection.label} className='font-lg mb-0 mr-3'>{subsection.label}</p>}
              {toggleField}
            </div>
          : null}
          {subsectionFields}
        </div>
      })

      let sectionFields = section.keys.map(key => {
        const field = renderField[get(formSchema, `${key}.type`, 'text')](key, form, formSchema, fieldSettings, updateField, saveForm, isReadOnly, errors, setErrors, spaceProfilePhotos, setSpaceProfilePhotos);
        return field && <div key={key} className={`${styles.field} pr-5`} style={section.width || get(formSchema, `${key}.width`) ? { width: get(formSchema, `${key}.width`) || section.width } : {}}>{field}</div>
      });

      sectionFields = sectionFields.filter(_ => _);
      subsections = subsections.filter(_ => _);

      Object.keys(insertValues).forEach(key => {
        let index;
        sectionFields.forEach((section, i) => {
          if (key === section.key) index = i
        });
        if (index) sectionFields.splice(index + 1, 0, <div key={`${key}${insertValues[key]}`} className={`${styles.field} pr-5`} style={section.width ? { width: section.width } : {}}>{insertValues[key]}</div>);
      })

      return <section key={'' + section.label + i} className="d-flex w-100 flex-wrap">
        {
          section.label && (hasEnabledFields(section.keys, formSchema, fieldSettings) || subsections.length > 0) && <p className='font-xl font-weight-bold mt-sm-5 mb-sm-3 mt-4 mb-2 w-100' style={{ flexShrink: 0 }}>{section.label}</p>
        }
        {sectionFields}
        {subsections}
      </section>
    })

    const toggleClass = `accordionArrow${openSection === category.label ? 'Minus' : 'Plus'}`;

    return <Card key={category.label} className={styles.accordionCard}>
      <Accordion.Toggle as={Card.Header} eventKey={category.label}>
        <h2 className='is-main-heading'>{category.label}<span className={`${styles.accordionArrow} ${styles[toggleClass]}`}></span></h2>
      </Accordion.Toggle>
      <Accordion.Collapse eventKey={category.label}>
        <Card.Body className='py-4 px-0'>
          <Form key="basic_form" className='is-common-form'>
            <section className="d-flex w-100 flex-wrap">
              {i < embeddedContent.length && embeddedContent[i].top ? embeddedContent[i].top : null}
            </section>
            {layout}
            <section className="d-flex w-100 flex-wrap">
              {i < embeddedContent.length && embeddedContent[i].bottom ? embeddedContent[i].bottom : null}
            </section>
          </Form>
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  })
}

export default BuildForm;